import { API, graphqlOperation } from "aws-amplify";
import { GetDetailsOfCurrentUser } from "../graphql/queries";

export const GetCurrentUserDetails = {
  data() {
    return {
      GetCurrentUserDetailsObject: {},
    };
  },
  methods: {
    async GetCurrentUserDetailsMethod() {
      try {
        var self = this;
        self.overlay = true;
        const result = await API.graphql(
          graphqlOperation(GetDetailsOfCurrentUser, {
            input: {
              user_email_id: self.$store.getters.get_user_email,
            },
          })
        );
        self.overlay = false;
        self.GetCurrentUserDetailsObject = await JSON.parse(result.data.GetDetailsOfCurrentUser).response[0];
        self.$store.commit("SET_CURRENTUSER_DETAILS", this.GetCurrentUserDetailsObject);
        return self.GetCurrentUserDetailsObject;
      } catch (err) {
        console.log(err);
        self.overlay = false;
        self.$router.push("/");
      }
    },
  },
};
